import React from 'react';
import { Button } from '../ui/Button';
import { Check, Snowflake } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bullets = ['Pack completo: 6 recetarios (PDF)', '30 recetas por kit (180 recetas total)', 'Pensado para cocinar por tandas y congelar'];
  return <section className="relative pt-10 pb-10 md:pt-20 md:pb-20 px-4 overflow-hidden" data-id="element-96">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-ice via-[#F8F5F0] to-[#F8F5F0]" data-id="element-97" />

      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-brand-frost rounded-full blur-3xl opacity-60" data-id="element-98" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-frost/40 rounded-full blur-3xl" data-id="element-99" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-101">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-white border border-brand-slate-200 shadow-sm mb-6 md:mb-8" data-id="element-102">
            <Snowflake className="w-4 h-4 text-brand-sky" data-id="element-103" />
            <span className="text-xs md:text-sm font-medium text-brand-slate-700" data-id="element-104">
              Pack completo de recetas freezer-friendly
            </span>
          </div>

          <h1 className="text-3xl md:text-6xl lg:text-7xl font-extrabold text-brand-slate-900 leading-[1.1] tracking-tight mb-5 md:mb-6" style={{
          fontSize: '24px'
        }} data-id="element-105">
            Elegí tu estilo y llená tu freezer con comidas listas{' '}
            <span className="text-brand-sky block md:inline" data-id="element-106">
              (sin aburrirte)
            </span>
          </h1>

          <p className="text-base md:text-xl text-brand-slate-600 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-107">
            6 kits en PDF, 30 recetas cada uno (180 total). Clásico, Kids,
            Ahorro, Low Carb/Keto, Sin Gluten y Vegano.
          </p>

          {/* Product mockup image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="mb-8 md:mb-10" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/9excLcgnmtCpw1SP8tXcXh/Generated_Image_February_05,_2026_-_6_19PM.jpg" alt="Sistema Freezer Fit — Pack 6 Kits" className="mx-auto w-full max-w-2xl rounded-xl" data-id="element-109" />
          </motion.div>

          {/* Bullets */}
          <div className="flex flex-col gap-3 mb-8 md:mb-10 max-w-lg mx-auto md:max-w-none" data-id="element-110">
            {bullets.map((bullet, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3 + i * 0.1
          }} className="flex items-start md:items-center gap-2.5 bg-white px-3.5 py-2.5 rounded-lg border border-brand-slate-200 shadow-sm text-left" data-id="element-111">
                <Check className="w-5 h-5 text-brand-sky flex-shrink-0 mt-0.5 md:mt-0" data-id="element-112" />
                <span className="text-sm text-brand-slate-700" data-id="element-113">{bullet}</span>
              </motion.div>)}
          </div>

          {/* CTA */}
          <div className="flex flex-col items-center gap-3" data-id="element-114">
            <Button size="lg" onClick={scrollToPricing} className="text-base md:text-lg" data-id="element-115">
              Quiero el Pack 6 Kits
            </Button>
            <span className="text-xs text-brand-slate-400" data-id="element-116">
              Precio de lanzamiento · 180 recetas
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}